import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
`;
export const Inner = styled.div`
  flex: 1;
  height: 100%;
  overflow: hidden;
`;
export const BackButtonContainer = styled.div`
  margin: 15px 20px;
`;
export const BackButton = styled.div`
  font-family: AvenirNext-Medium;
  font-size: 13px;
  font-weight: 500;
  color: #4a90e2;
  cursor: pointer;
`;
